import React, {useContext, useEffect, useRef, useState} from 'react'
import s from './Roulette.module.scss'
import classNames from 'classnames'
import GameConfigContext from '../../../../context/GameConfigContext'
import {getRandomAngleDeviation} from "../../../../utils/randomAngleDeviation";
import {
    drizzleSegmentColorsPalette,
    Result,
    RiskType, segmentColorsPalette,
    SegmentColorType,
    segmentCounts,
    SegmentCountType,
    wheelSchemas,
} from "../../../../types/Game";
import {randomTargetSegmentIndex} from "../../../../utils/randomTargetSegmentIndex";

const Roulette: React.FC<IProps> = ({ gameResult, selectedRiskType, selectedSegmentsCount, isGame, isDrizzlePartner }) => {
    const [{ isTurboMode }] = useContext(GameConfigContext)

    const segments = wheelSchemas[selectedRiskType][selectedSegmentsCount]

    const palette = isDrizzlePartner ? drizzleSegmentColorsPalette : segmentColorsPalette
    const segmentCount = segmentCounts[selectedSegmentsCount]
    const segmentAngle = useRef(360 / segmentCount)
    const angleDeviationRef = useRef(0)
    const startAngleRef = useRef(-90 - segmentAngle.current / 2)

    const [rotation, setRotation] = useState(startAngleRef.current)

    const calculateRotation = (prevRotation: number, result: SegmentColorType) => {
        const resultIndex = randomTargetSegmentIndex(segments, result)

        let startAngle = prevRotation - angleDeviationRef.current

        if ((prevRotation - startAngleRef.current) % 360 === 0) {
            startAngle = startAngleRef.current
        }

        const randomAngleDeviation = getRandomAngleDeviation(segmentAngle.current - 1)

        const targetAngle = startAngle + 360 * 5 + (360 - resultIndex * segmentAngle.current) + randomAngleDeviation
        angleDeviationRef.current = (targetAngle - startAngleRef.current) % 360
        setRotation(targetAngle)
    }

    useEffect(() => {
        if (!gameResult) return

        calculateRotation(rotation, gameResult.color)
    }, [gameResult])

    useEffect(() => {
        const segmentAngleTemp = 360 / segmentCount
        segmentAngle.current = 360 / segmentCount
        angleDeviationRef.current = 0
        startAngleRef.current = -90 - segmentAngleTemp / 2
        setRotation(-90 - segmentAngleTemp / 2)
    }, [segmentCount])

    return (
        <div className={s.roulette}>
            <svg
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 24 24"
                fill="#FF3333"
                className={classNames("size-8", s.target)}
            >
                <path
                    d="M3.478 2.404a.75.75 0 0 0-.926.941l2.432 7.905H13.5a.75.75 0 0 1 0 1.5H4.984l-2.432 7.905a.75.75 0 0 0 .926.94 60.519 60.519 0 0 0 18.445-8.986.75.75 0 0 0 0-1.218A60.517 60.517 0 0 0 3.478 2.404Z"/>
            </svg>
            <svg
                width="300"
                height="300"
                viewBox="0 0 300 300"
                style={{
                    transform: `rotate(${rotation}deg)`,
                    transformOrigin: 'center',
                    transition: !isTurboMode && isGame ? 'transform 3s ease' : 'none'
                }}
            >
                {segments.map((segment, index) => {
                    const startAngle = index * segmentAngle.current;
                    const endAngle = startAngle + segmentAngle.current;

                    const startX = 150 + 140 * Math.cos((startAngle * Math.PI) / 180);
                    const startY = 150 + 140 * Math.sin((startAngle * Math.PI) / 180);
                    const endX = 150 + 140 * Math.cos((endAngle * Math.PI) / 180);
                    const endY = 150 + 140 * Math.sin((endAngle * Math.PI) / 180);

                    const largeArcFlag = segmentAngle.current > 180 ? 1 : 0;

                    return (
                        <path
                            key={index}
                            d={`M ${startX} ${startY} A 140 140 0 ${largeArcFlag} 1 ${endX} ${endY}`}
                            stroke={palette[segment]}
                            strokeWidth="10"
                            fill="none"
                        />
                    );
                })}
            </svg>
            <div
                className={s.result}
                key={gameResult?.color}
                style={{
                    color: palette[gameResult?.color!] ?? 'transparent',
                    borderColor: palette[gameResult?.color!] ?? 'transparent',
                    animationDelay: isTurboMode ? '0' : '3s',
                }}
            >
                {gameResult?.odd}x
            </div>
        </div>
    )
}

export default Roulette

interface IProps {
    gameResult: Result | null
    selectedRiskType: RiskType
    selectedSegmentsCount: SegmentCountType
    isGame: boolean
    isDrizzlePartner: boolean
}